const clone = value => JSON.parse(JSON.stringify(value))

const nowIso = () => new Date().toISOString()

export const CS_ASSIGNEES = [
  { id: 901, name: '박CS매니저', department: '고객성공팀', role: 'cs' },
  { id: 902, name: '최운영', department: '운영팀', role: 'cs' },
]

export const TECHNICAL_ASSIGNEES = [
  { id: 951, name: '김프론트', department: '제품개발팀', role: 'technical' },
  { id: 952, name: '이백엔드', department: '플랫폼개발팀', role: 'technical' },
  { id: 953, name: '정데이터엔지니어', department: '데이터엔지니어링팀', role: 'technical' },
]

const people = {
  user: { id: 101, name: '김리컬럼', role: 'user', organizationId: 10 },
  org_admin: { id: 102, name: '이조직관리자', role: 'org_admin', organizationId: 10 },
  cs_admin: { id: 901, name: '박CS매니저', role: 'cs_admin', organizationId: 1 },
}

const organizations = {
  mine: { id: 10, name: '리컬럼 고객사' },
  other: { id: 20, name: '데이터웍스' },
}

const rootOrganizations = {
  mine: { id: 100, name: '리컬럼 그룹' },
  other: { id: 200, name: '데이터웍스 그룹' },
}

const seedProjectNames = {
  1: '매출 분석 프로젝트',
  2: '발주 자동화 프로젝트',
  3: '권한 관리 프로젝트',
  4: '재고 운영 프로젝트',
}

const rootOrganizationFor = organization => (
  organization?.id === organizations.other.id ? rootOrganizations.other : rootOrganizations.mine
)

const makeComment = (id, author, body, createdAt, extra = {}) => ({
  id,
  author,
  body,
  createdAt,
  visibility: 'public',
  requestInfo: false,
  attachments: [],
  ...extra,
})

const additionalSeedTickets = () => [
  { id: 5, date: '0713', time: '14:20', title: 'CSV 업로드 시 한글이 깨져 보입니다', type: '파일·데이터 관련', status: '확인 중', priority: '보통', waitingFor: 'recolumn', reporter: people.user, organization: organizations.mine, assignee: CS_ASSIGNEES[0], workflow: { id: 704, name: '고객 데이터 정제' }, description: 'UTF-8 CSV 파일의 한글 컬럼명이 깨져 표시됩니다.' },
  { id: 6, date: '0713', time: '11:05', title: '워크플로우 실행 예약 시간을 변경하고 싶어요', type: '기능 문의·개선 요청', status: '고객 답변 대기', priority: '낮음', waitingFor: 'customer', reporter: people.org_admin, organization: organizations.mine, assignee: CS_ASSIGNEES[0], workflow: { id: 705, name: '일일 정산 리포트' }, description: '공휴일에는 실행 예약을 건너뛰는 방법이 궁금합니다.' },
  { id: 7, date: '0712', time: '16:45', title: '결과 파일 다운로드가 오래 걸립니다', type: '파일·데이터 관련', status: '조치 중', priority: '높음', waitingFor: 'recolumn', reporter: { id: 202, name: '최분석', role: 'user', organizationId: 20 }, organization: organizations.other, assignee: CS_ASSIGNEES[0], workflow: { id: 706, name: '대용량 로그 분석' }, description: '2GB 결과 파일 다운로드가 완료되지 않습니다.' },
  { id: 8, date: '0712', time: '09:30', title: '세금계산서 수신 이메일 변경 요청', type: '결제·계약', status: '종료', priority: '보통', waitingFor: 'none', reporter: people.org_admin, organization: organizations.mine, assignee: CS_ASSIGNEES[1], workflow: null, description: '다음 결제부터 세금계산서 수신 주소를 변경해 주세요.' },
  { id: 9, date: '0711', time: '17:10', title: '조인 결과에서 중복 행이 생성됩니다', type: '워크플로우 결과 이상', status: '재오픈', priority: '긴급', waitingFor: 'recolumn', reporter: people.user, organization: organizations.mine, assignee: CS_ASSIGNEES[0], workflow: { id: 707, name: '고객 주문 통합' }, description: '고객 키로 조인한 뒤 동일 주문이 두 건씩 생성됩니다.' },
  { id: 10, date: '0711', time: '13:55', title: '외부 사용자 초대 메일이 오지 않습니다', type: '계정·권한', status: '접수', priority: '높음', waitingFor: 'recolumn', reporter: { id: 203, name: '한관리', role: 'org_admin', organizationId: 20 }, organization: organizations.other, assignee: null, workflow: null, description: '새 멤버에게 보낸 초대 메일이 수신되지 않습니다.' },
  { id: 11, date: '0710', time: '15:25', title: '날짜 변환 블록에서 형식 오류가 발생합니다', type: '워크플로우 실행 오류', status: '확인 중', priority: '보통', waitingFor: 'recolumn', reporter: people.user, organization: organizations.mine, assignee: CS_ASSIGNEES[1], workflow: { id: 708, name: '근태 데이터 변환' }, description: 'YYYYMMDD 값을 날짜로 변환할 때 실행이 실패합니다.' },
  { id: 12, date: '0710', time: '10:40', title: '사용하지 않는 프로젝트를 정리하고 싶습니다', type: '기능 문의·개선 요청', status: '해결 확인 대기', priority: '낮음', waitingFor: 'customer', reporter: people.org_admin, organization: organizations.mine, assignee: CS_ASSIGNEES[0], workflow: null, description: '프로젝트 보관과 영구 삭제의 차이를 알고 싶습니다.' },
  { id: 13, date: '0709', time: '16:00', title: 'API 사용량 확인 방법 문의', type: '결제·계약', status: '고객 답변 대기', priority: '보통', waitingFor: 'customer', reporter: { id: 204, name: '윤데이터', role: 'user', organizationId: 20 }, organization: organizations.other, assignee: CS_ASSIGNEES[0], workflow: null, description: '월별 API 호출량과 초과 비용을 확인하고 싶습니다.' },
  { id: 14, date: '0709', time: '09:15', title: '엑셀 수식이 결과 파일에서 사라집니다', type: '워크플로우 결과 이상', status: '조치 중', priority: '높음', waitingFor: 'recolumn', reporter: people.user, organization: organizations.mine, assignee: CS_ASSIGNEES[0], workflow: { id: 709, name: '주간 영업 현황' }, description: '템플릿에 포함된 합계 수식이 결과 파일에서 값으로 변경됩니다.' },
  { id: 15, date: '0708', time: '18:05', title: '워크스페이스 이름 변경이 가능한가요', type: '기타', status: '종료', priority: '낮음', waitingFor: 'none', reporter: people.org_admin, organization: organizations.mine, assignee: CS_ASSIGNEES[1], workflow: null, description: '기존 데이터 유지 상태로 워크스페이스 이름을 변경하고 싶습니다.' },
].map(item => {
  const createdAt = `2026-07-${item.date.slice(2)}T${item.time}:00+09:00`
  const execution = item.workflow && item.type.includes('워크플로우')
    ? { id: 8800 + item.id, startedAt: createdAt, status: item.type === '워크플로우 실행 오류' ? 'Failed' : 'Finished' }
    : null
  return {
    id: item.id,
    number: `CS-2026-${item.date}-${String(item.id).padStart(3, '0')}`,
    title: item.title,
    type: item.type,
    status: item.status,
    priority: item.priority,
    waitingFor: item.waitingFor,
    reporter: clone(item.reporter),
    organization: clone(item.organization),
    assignee: item.assignee ? clone(item.assignee) : null,
    workflow: item.workflow ? clone(item.workflow) : null,
    execution,
    description: item.description,
    expectedResult: '',
    importance: item.priority,
    tags: [],
    cause: '',
    reproducible: '미확인',
    developmentIssue: '',
    targetFirstResponseAt: createdAt,
    targetResolutionAt: `2026-07-${item.date.slice(2)}T23:00:00+09:00`,
    unreadBy: item.status === '접수' ? ['cs_admin'] : [],
    updatedAt: createdAt,
    createdAt,
    attachments: [],
    snapshot: execution ? {
      workflow: { ...clone(item.workflow), version: 1 },
      execution: clone(execution),
      primaryBlock: null,
      relatedBlocks: [],
      logs: ['더미 실행 진단 자료입니다.'],
      warning: '',
    } : null,
    comments: [],
    internalNotes: [],
    history: [{ id: item.id, type: 'created', label: '티켓이 접수되었습니다.', createdAt }],
  }
})

const seedTickets = () => [
  {
    id: 1,
    number: 'CS-2026-0716-001',
    title: '월별 매출 집계 결과가 예상과 달라요',
    type: '워크플로우 결과 이상',
    status: '해결 확인 대기',
    priority: '높음',
    waitingFor: 'customer',
    reporter: clone(people.user),
    organization: clone(organizations.mine),
    assignee: clone(CS_ASSIGNEES[0]),
    workflow: { id: 701, name: '월별 매출 집계' },
    execution: { id: 8801, startedAt: '2026-07-15T09:20:00+09:00', status: 'Finished' },
    description: '7월 매출 합계가 원본 파일의 합계와 다르게 표시됩니다.',
    expectedResult: '원본과 동일한 128,450,000원',
    importance: '높음',
    tags: ['결과 검증'],
    cause: '필터 조건',
    reproducible: '재현됨',
    developmentIssue: 'DEV-428',
    targetFirstResponseAt: '2026-07-15T11:20:00+09:00',
    targetResolutionAt: '2026-07-17T18:00:00+09:00',
    unreadBy: ['user'],
    updatedAt: '2026-07-16T10:15:00+09:00',
    createdAt: '2026-07-15T09:35:00+09:00',
    attachments: [
      { id: 'a1', name: '7월_매출결과.xlsx', kind: 'result', size: '2.4 MB', shared: true },
      { id: 'a2', name: '매출원본.xlsx', kind: 'input', size: '5.8 MB', shared: true },
    ],
    snapshot: {
      workflow: { id: 701, name: '월별 매출 집계', version: 12 },
      execution: { id: 8801, status: 'Finished', runParams: { month: '2026-07' } },
      primaryBlock: { id: 31, name: '거래일 필터', type: 'Table Filter', status: 'success' },
      relatedBlocks: [],
      logs: ['09:20 실행 시작', '09:21 거래일 필터 8,432행 처리', '09:22 결과 파일 생성'],
      warning: '',
    },
    comments: [
      makeComment(1, clone(people.user), '원본과 결과 파일을 함께 확인 부탁드립니다.', '2026-07-15T09:35:00+09:00'),
      makeComment(2, clone(people.cs_admin), '필터 범위를 수정했습니다. 결과를 확인해 주세요.', '2026-07-16T10:15:00+09:00'),
    ],
    internalNotes: [{ id: 1, author: clone(people.cs_admin), body: '7월 1일 00시 데이터가 제외되는 조건 확인.', createdAt: '2026-07-16T09:10:00+09:00', visibility: 'internal' }],
    history: [{ id: 1, type: 'status', label: '상태가 해결 확인 대기로 변경됨', createdAt: '2026-07-16T10:15:00+09:00' }],
  },
  {
    id: 2,
    number: 'CS-2026-0716-002',
    title: '발주서 병합 단계에서 실행이 중단됩니다',
    type: '워크플로우 실행 오류',
    status: '조치 중',
    priority: '긴급',
    waitingFor: 'recolumn',
    reporter: { id: 201, name: '정데이터', role: 'user', organizationId: 20 },
    organization: clone(organizations.other),
    assignee: clone(CS_ASSIGNEES[0]),
    technicalAssignees: clone(TECHNICAL_ASSIGNEES.slice(0, 2)),
    workflow: { id: 702, name: '발주서 자동 병합' },
    execution: { id: 8802, startedAt: '2026-07-16T08:12:00+09:00', status: 'Failed' },
    description: '파일 병합 블록이 빨간색으로 바뀐 뒤 결과가 생성되지 않습니다.',
    expectedResult: '',
    importance: '긴급',
    tags: ['실행 오류', '대용량'],
    cause: '메모리 부족',
    reproducible: '재현 중',
    developmentIssue: '',
    targetFirstResponseAt: '2026-07-16T09:12:00+09:00',
    targetResolutionAt: '2026-07-16T17:00:00+09:00',
    unreadBy: ['cs_admin'],
    updatedAt: '2026-07-16T09:03:00+09:00',
    createdAt: '2026-07-16T08:20:00+09:00',
    attachments: [{ id: 'a3', name: '발주서_32개.zip', kind: 'input', size: '820 MB', shared: true, state: 'preparing' }],
    snapshot: {
      workflow: { id: 702, name: '발주서 자동 병합', version: 5 },
      execution: { id: 8802, status: 'Failed', runParams: { files: 32 } },
      primaryBlock: { id: 44, name: '전체 시트 병합', type: 'UnionAllSheet', status: 'failed', error: 'Worker memory limit exceeded' },
      relatedBlocks: [{ id: 43, name: '파일 가져오기', type: 'FileInput', status: 'success' }],
      logs: ['08:12 실행 시작', '08:14 일부 진단 자료 수집 실패'],
      warning: '일부 진단 자료 수집 실패 · 대용량 파일 미리보기 준비 중',
    },
    comments: [makeComment(3, { id: 201, name: '정데이터', role: 'user' }, '오늘 발주 업무가 막혀 있습니다.', '2026-07-16T08:20:00+09:00')],
    internalNotes: [],
    history: [{ id: 2, type: 'created', label: '실패한 실행에서 티켓이 생성됨', createdAt: '2026-07-16T08:20:00+09:00' }],
  },
  {
    id: 3,
    number: 'CS-2026-0715-003',
    title: '프로젝트 멤버 권한을 변경하고 싶습니다',
    type: '계정·권한',
    status: '고객 답변 대기',
    priority: '보통',
    waitingFor: 'customer',
    reporter: clone(people.org_admin),
    organization: clone(organizations.mine),
    assignee: null,
    workflow: null,
    execution: null,
    description: '프로젝트별로 다운로드 권한만 부여할 수 있는지 궁금합니다.',
    expectedResult: '',
    importance: '보통',
    tags: [],
    cause: '',
    reproducible: '해당 없음',
    developmentIssue: '',
    targetFirstResponseAt: '2026-07-16T12:00:00+09:00',
    targetResolutionAt: '2026-07-18T18:00:00+09:00',
    unreadBy: [],
    updatedAt: '2026-07-16T09:40:00+09:00',
    createdAt: '2026-07-15T17:40:00+09:00',
    attachments: [],
    snapshot: null,
    comments: [makeComment(4, clone(people.cs_admin), '현재 멤버의 권한 수준을 알려주세요.', '2026-07-16T09:40:00+09:00', { requestInfo: true })],
    internalNotes: [],
    history: [],
  },
  {
    id: 4,
    number: 'CS-2026-0714-004',
    title: '삭제된 실행 이력의 오류를 확인하고 싶습니다',
    type: '워크플로우 실행 오류',
    status: '접수',
    priority: '높음',
    waitingFor: 'recolumn',
    reporter: clone(people.user),
    organization: clone(organizations.mine),
    assignee: null,
    workflow: { id: 703, name: '재고 현황 생성' },
    execution: { id: 8803, startedAt: '2026-07-14T15:30:00+09:00', status: 'Deleted' },
    description: '실행 이력은 삭제했지만 당시 오류 원인이 필요합니다.',
    expectedResult: '',
    importance: '높음',
    tags: ['원본 삭제'],
    cause: '',
    reproducible: '미확인',
    developmentIssue: '',
    targetFirstResponseAt: '2026-07-14T17:30:00+09:00',
    targetResolutionAt: '2026-07-16T18:00:00+09:00',
    unreadBy: ['cs_admin'],
    updatedAt: '2026-07-14T15:45:00+09:00',
    createdAt: '2026-07-14T15:45:00+09:00',
    attachments: [{ id: 'a4', name: '삭제된_실행결과.xlsx', kind: 'result', size: '-', shared: true, state: 'deleted' }],
    snapshot: {
      workflow: { id: 703, name: '재고 현황 생성 (신고 당시)', version: 2 },
      execution: { id: 8803, status: 'Deleted' },
      primaryBlock: { id: 56, name: '재고 키 조인', type: 'Join', status: 'failed', error: 'Key column not found' },
      relatedBlocks: [],
      logs: ['원본 실행은 삭제되었으며 저장된 스냅샷을 표시합니다.'],
      warning: '원본 실행 삭제 · 현재 워크플로우는 버전 4로 변경됨',
    },
    comments: [],
    internalNotes: [],
    history: [],
  },
  ...additionalSeedTickets(),
].map(ticket => {
  const projectName = seedProjectNames[ticket.id] || (ticket.workflow ? `${ticket.workflow.name} 프로젝트` : '')
  return {
    technicalAssignees: [],
    rootOrganization: clone(rootOrganizationFor(ticket.organization)),
    project: clone(ticket.project || ticket.snapshot?.project || (projectName ? { id: 3000 + ticket.id, name: projectName } : null)),
    ...ticket,
  }
})

export const ISSUE_TYPES = ['워크플로우 실행 오류', '워크플로우 결과 이상', '파일·데이터 관련', '계정·권한', '결제·계약', '기능 문의·개선 요청', '기타']
export const ISSUE_STATUSES = ['접수', '확인 중', '고객 답변 대기', '조치 중', '해결 확인 대기', '종료', '재오픈']
export const ISSUE_PRIORITIES = ['낮음', '보통', '높음', '긴급']

const ISSUE_STATUS_TONES = {
  접수: 'gray',
  '확인 중': 'blue',
  '고객 답변 대기': 'orange',
  '조치 중': 'red',
  '해결 확인 대기': 'purple',
  종료: 'green',
  재오픈: 'red',
}

export function getCSIssueStatusTone(status) {
  return ISSUE_STATUS_TONES[status] || 'gray'
}

export function normalizeCSIssueOriginPath(path) {
  if (typeof path !== 'string') return null
  if (path !== path.trim()) return null
  const normalized = path
  if (!/^\/(?!\/)/.test(normalized)) return null
  if (normalized.includes('\\')) return null
  if ([...normalized].some(character => {
    const code = character.charCodeAt(0)
    return code < 32 || (code >= 127 && code <= 159)
  })) return null
  return normalized
}

export function normalizeCSIssueBlockFocusId(blockId) {
  if (typeof blockId !== 'string' && typeof blockId !== 'number') return null
  const normalized = String(blockId)
  if (normalized !== normalized.trim()) return null
  return /^[A-Za-z0-9_-]{1,128}$/.test(normalized) ? normalized : null
}

export function buildCSWorkflowDesignPath(projectId, workflowId) {
  const normalizedProjectId = normalizeCSIssueBlockFocusId(projectId)
  const normalizedWorkflowId = normalizeCSIssueBlockFocusId(workflowId)
  if (!normalizedProjectId || !normalizedWorkflowId) return null
  return `/rpa/${normalizedProjectId}/${normalizedWorkflowId}?panel=design`
}

function isCSWorkflowDesignPath(path) {
  if (!path) return false
  const target = new URL(path, 'https://recolumn.local')
  const segments = target.pathname.split('/').filter(Boolean)
  return ['rpa', 'rpa3'].includes(segments[0])
    && segments.length === 3
    && normalizeCSIssueBlockFocusId(segments[1]) === segments[1]
    && normalizeCSIssueBlockFocusId(segments[2]) === segments[2]
}

export function buildCSIssueOriginTarget(path, primaryBlockId, context = {}) {
  let normalizedPath = normalizeCSIssueOriginPath(path)
  if (context.source === 'workflow-error' && !isCSWorkflowDesignPath(normalizedPath)) {
    normalizedPath = buildCSWorkflowDesignPath(context.projectId, context.workflowId)
  }
  if (!normalizedPath) return null
  const blockId = normalizeCSIssueBlockFocusId(primaryBlockId)
  if (!blockId) return normalizedPath
  const target = new URL(normalizedPath, 'https://recolumn.local')
  target.searchParams.set('csBlockId', blockId)
  return `${target.pathname}${target.search}${target.hash}`
}

export function getCSIssueSourceLabel(context = {}) {
  if (context.source === 'project-navbar') {
    const workflowDesignRoutes = ['RpaMain', 'RpaMain3']
    const isWorkflowDesign = workflowDesignRoutes.includes(context.originScreen?.routeName)
      || context.originScreen?.name === '워크플로우 설계'
    return isWorkflowDesign ? '워크플로우 설계창' : '프로젝트 상단바'
  }

  return ({
    menu: 'CS 메뉴 직접 등록',
    'data-result': '데이터 결과 파일',
    'workflow-result': '워크플로우 결과 화면',
    'workflow-error': '워크플로우 실행창',
  })[context.source] || context.source
}

export function isContextualWorkflowEntry(context = {}) {
  if (['workflow-error', 'workflow-result'].includes(context.source)) return true
  if (context.source !== 'project-navbar' || !context.workflow) return false
  return ['RpaMain', 'RpaMain3'].includes(context.originScreen?.routeName)
    || ['워크플로우 설계', '워크플로우 설계창'].includes(context.originScreen?.name)
}

export function getLatestCSExecution(executions = []) {
  return Array.isArray(executions) && executions.length > 0 ? clone(executions[0]) : null
}

export function getContextualCSExecution(capturedExecution, executions = []) {
  if (capturedExecution?.id != null) {
    const loadedExecution = executions.find(execution => String(execution?.id) === String(capturedExecution.id))
    return clone(loadedExecution || capturedExecution)
  }
  return getLatestCSExecution(executions)
}

export function getCSExecutionOutputs(execution, capturedResultFiles = []) {
  if (Array.isArray(execution?.outputs) && execution.outputs.length > 0) return clone(execution.outputs)
  return clone(Array.isArray(capturedResultFiles) ? capturedResultFiles : [])
}

const CS_WORKFLOW_RUN_ERROR_KEYS = [
  'result', 'success', 'fail', 'fail_type', 'error', 'timestamp', 'time_log', 'is_thread',
  'err_code', 'err_msg', 'message', 'detail', 'activity_id', 'failed_activity_id',
]

export function normalizeCSWorkflowRunErrorResponse(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null
  const normalized = {}
  CS_WORKFLOW_RUN_ERROR_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(payload, key) && payload[key] !== undefined) {
      normalized[key] = clone(payload[key])
    }
  })
  return Object.keys(normalized).length ? normalized : null
}

export function getCSWorkflowRunErrorMessage(payload) {
  if (payload == null) return ''
  if (typeof payload === 'string') return payload
  if (typeof payload !== 'object') return String(payload)
  const error = payload.error
  if (typeof error === 'string') return error
  if (error && typeof error === 'object') {
    const nested = error.message ?? error.err_msg ?? error.detail ?? error.error
    if (nested != null && nested !== error) return getCSWorkflowRunErrorMessage(nested)
    try { return JSON.stringify(error) } catch (serializationError) { return String(error) }
  }
  const direct = payload.message ?? payload.err_msg ?? payload.detail
  return direct == null ? '' : getCSWorkflowRunErrorMessage(direct)
}

function getCSWorkflowRunFailureId(payload = {}) {
  const failure = payload.fail ?? payload.failed_activity_id ?? payload.activity_id
  if (failure && typeof failure === 'object') {
    return failure.id ?? failure.activity_id ?? failure.failed_activity_id ?? failure.fail ?? null
  }
  return failure ?? null
}

export function buildCSWorkflowRunFailureBlock(blocks = [], payload = {}) {
  const failure = payload.fail ?? payload.failed_activity_id ?? payload.activity_id
  const failureId = getCSWorkflowRunFailureId(payload)
  const matchedBlock = failureId == null
    ? null
    : (blocks || []).find(block => String(block?.id) === String(failureId))
  const responseBlock = failure && typeof failure === 'object' ? failure : null
  const sourceBlock = matchedBlock || responseBlock
  if (!sourceBlock) return null
  return {
    ...clone(sourceBlock),
    status: 'failed',
    run_status: 'fail',
    error: getCSWorkflowRunErrorMessage(payload) || sourceBlock.error,
  }
}

export function resolveCSDiagnosticBlock(primaryBlock, designBlocks = [], workflowRunError = null) {
  if (!primaryBlock) return null
  const designBlock = (designBlocks || []).find(block => String(block?.id) === String(primaryBlock.id))
  const failureId = getCSWorkflowRunFailureId(workflowRunError || {})
  const isCapturedFailure = primaryBlock.run_status === 'fail'
    || primaryBlock.status === 'failed'
    || (failureId != null && String(failureId) === String(primaryBlock.id))
  const resolved = {
    ...(designBlock ? clone(designBlock) : {}),
    ...clone(primaryBlock),
    error: primaryBlock.error || designBlock?.error,
  }
  if (isCapturedFailure) {
    resolved.status = 'failed'
    resolved.run_status = 'fail'
  }
  return resolved
}

export function createInitialState() {
  return {
    tickets: seedTickets(),
    drafts: {},
    demoRole: 'user',
    nextTicketId: 16,
    nextCommentId: 20,
    nextNoteId: 20,
    nextDraftId: 1,
    notifications: [
      {
        id: 'seed-cs-assigned-2-901',
        kind: '담당자 배정',
        title: '박CS매니저님이 CS 담당자로 배정되었습니다.',
        message: 'CS-2026-0716-002 · 발주서 병합 단계에서 실행이 중단됩니다',
        ticketId: 2,
        recipientRole: 'cs_admin',
        recipient: clone(CS_ASSIGNEES[0]),
        assignmentType: 'cs',
        assignmentAction: 'assigned',
        isRead: false,
        createdAt: '2026-07-28T09:03:00+09:00',
      },
      {
        id: 'seed-technical-assigned-2-951',
        kind: '담당자 배정',
        title: '김프론트님이 기술 담당자로 배정되었습니다.',
        message: 'CS-2026-0716-002 · 발주서 병합 단계에서 실행이 중단됩니다',
        ticketId: 2,
        recipientRole: 'cs_admin',
        recipient: clone(TECHNICAL_ASSIGNEES[0]),
        assignmentType: 'technical',
        assignmentAction: 'assigned',
        isRead: false,
        createdAt: '2026-07-28T09:02:00+09:00',
      },
      {
        id: 'seed-technical-assigned-2-952',
        kind: '담당자 배정',
        title: '이백엔드님이 기술 담당자로 배정되었습니다.',
        message: 'CS-2026-0716-002 · 발주서 병합 단계에서 실행이 중단됩니다',
        ticketId: 2,
        recipientRole: 'cs_admin',
        recipient: clone(TECHNICAL_ASSIGNEES[1]),
        assignmentType: 'technical',
        assignmentAction: 'assigned',
        isRead: false,
        createdAt: '2026-07-28T09:01:00+09:00',
      },
      {
        id: 'seed-technical-released-1-953',
        kind: '담당 해제',
        title: '정데이터엔지니어님의 기술 담당 배정이 해제되었습니다.',
        message: 'CS-2026-0716-001 · 월별 매출 집계 결과가 예상과 달라요',
        ticketId: 1,
        recipientRole: 'cs_admin',
        recipient: clone(TECHNICAL_ASSIGNEES[2]),
        assignmentType: 'technical',
        assignmentAction: 'released',
        isRead: true,
        createdAt: '2026-07-28T09:00:00+09:00',
      },
      {
        id: 'notice-sla',
        kind: 'SLA 임박',
        title: 'CS 문의 SLA 임박',
        message: 'CS-2026-0716-002 목표 해결 시간이 2시간 남았습니다.',
        ticketId: 2,
        recipientRole: 'cs_admin',
        isRead: false,
        createdAt: nowIso(),
      },
      {
        id: 'notice-comment',
        kind: '새 댓글',
        title: 'CS 문의에 새 답변이 등록되었습니다.',
        message: '월별 매출 집계 이슈에 운영자 답변이 등록되었습니다.',
        ticketId: 1,
        recipientRole: 'user',
        isRead: false,
        createdAt: nowIso(),
      },
    ],
  }
}

export function roleFromPermission(permission) {
  if (permission === 'super_admin') return 'cs_admin'
  if (permission === 'admin') return 'org_admin'
  return 'user'
}

export function actorForRole(role) {
  return clone(people[role] || people.user)
}

export function canAccessTicket(ticket, role) {
  if (!ticket) return false
  if (role === 'cs_admin') return true
  if (role === 'org_admin') return ticket.organization?.id === organizations.mine.id
  return ticket.reporter?.id === people.user.id
}

const queueMatches = (ticket, queue) => {
  if (!queue || queue === 'all') return true
  if (queue === 'unassigned') return ticket.status === '접수' || !ticket.assignee
  if (queue === 'mine') return ticket.assignee?.id === people.cs_admin.id
  if (queue === 'customer_waiting') return ticket.status === '고객 답변 대기'
  if (queue === 'working') return ticket.status === '조치 중'
  if (queue === 'resolution_waiting') return ticket.status === '해결 확인 대기'
  if (queue === 'closed') return ticket.status === '종료'
  if (queue === 'sla') return new Date(ticket.targetResolutionAt).getTime() <= Date.now() + 24 * 60 * 60 * 1000 && ticket.status !== '종료'
  return true
}

export function queryTickets(state, filters = {}) {
  const role = filters.role || state.demoRole
  const search = String(filters.search || '').trim().toLowerCase()
  const createdFrom = filters.createdFrom ? new Date(`${filters.createdFrom}T00:00:00`).getTime() : null
  const createdTo = filters.createdTo ? new Date(`${filters.createdTo}T23:59:59.999`).getTime() : null
  return state.tickets
    .filter(ticket => canAccessTicket(ticket, role))
    .filter(ticket => !filters.scope || filters.scope === 'all' || (filters.scope === 'mine' && ticket.reporter.id === actorForRole(role).id) || (filters.scope === 'assigned' && ticket.assignee?.id === people.cs_admin.id))
    .filter(ticket => !search || `${ticket.number} ${ticket.title}`.toLowerCase().includes(search))
    .filter(ticket => !filters.status || ticket.status === filters.status)
    .filter(ticket => !filters.type || ticket.type === filters.type)
    .filter(ticket => !filters.workflow || ticket.workflow?.name === filters.workflow)
    .filter(ticket => !filters.assignee
      || String(ticket.assignee?.id) === String(filters.assignee)
      || ticket.assignee?.name === filters.assignee)
    .filter(ticket => !filters.waitingFor || ticket.waitingFor === filters.waitingFor)
    .filter(ticket => createdFrom == null || new Date(ticket.createdAt).getTime() >= createdFrom)
    .filter(ticket => createdTo == null || new Date(ticket.createdAt).getTime() <= createdTo)
    .filter(ticket => queueMatches(ticket, filters.queue))
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
}

export function paginateTickets(tickets, page = 1, pageSize = 10) {
  const normalizedPageSize = Math.max(1, Number(pageSize) || 10)
  const normalizedPage = Math.max(1, Number(page) || 1)
  const start = (normalizedPage - 1) * normalizedPageSize
  return tickets.slice(start, start + normalizedPageSize)
}

const normalizedEntity = entity => entity ? clone(entity) : null

export function toCSIssueBlockContext(block) {
  if (!block) return null
  const safeBlock = {}
  const keys = ['id', 'name', 'edited_name', 'type', 'category', 'status', 'run_status', 'error']
  keys.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(block, key) && block[key] !== undefined) safeBlock[key] = clone(block[key])
  })
  return safeBlock
}

export function toCSIssueExecutionContext(execution) {
  if (!execution) return null
  const safeExecution = {}
  const keys = [
    'id', 'issue_number', 'status', 'started_at', 'startedAt', 'finished_at', 'ended_at',
    'running_time', 'duration', 'error', 'diagnostic_failed', 'workflow_id', 'rpa_id',
    'version', 'version_minor', 'failed_activity_id', 'activity_id', 'fail', 'inputs', 'outputs',
  ]
  keys.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(execution, key) && execution[key] !== undefined) safeExecution[key] = clone(execution[key])
  })
  return Object.keys(safeExecution).length > 0 ? safeExecution : null
}

export function toCSExecutionResultFile(output, executionFinishedAt = null) {
  if (!output) return null
  const source = clone(output)
  const isDeleted = Boolean(output.is_deleted || output.state === 'deleted')
  return {
    id: output.id ?? output.target_id ?? output.rpa_output_id ?? null,
    name: output.name || output.rpa_output_name || '결과 파일',
    size: output.size ?? null,
    sheetCount: output.table_cnt ?? output.sheet_count ?? null,
    category: output.category || 'file',
    executionFinishedAt,
    isDeleted,
    disabled: isDeleted,
    state: isDeleted ? 'deleted' : (output.state || 'ready'),
    deletedMessage: output.deleted_message || '',
    source,
  }
}

export function normalizeResultFiles(payload = {}) {
  if (Array.isArray(payload.resultFiles)) return clone(payload.resultFiles.filter(Boolean))
  return payload.resultFile ? [clone(payload.resultFile)] : []
}

export function normalizeExecutionSelection(source, execution) {
  return source === 'project-navbar' ? toCSIssueExecutionContext(execution) : normalizedEntity(execution)
}

export function createExecutionArtifacts(execution, mode = 'execution') {
  const safeExecution = toCSIssueExecutionContext(execution)
  if (safeExecution?.id == null) return { attachments: [], diagnostics: null }
  const executionId = safeExecution.id
  return {
    attachments: [
      { id: `auto-input-${executionId}`, name: `실행_${executionId}_입력.xlsx`, kind: '입력', size: '5.8 MB', shared: true, state: 'ready' },
      { id: `auto-result-${executionId}`, name: `실행_${executionId}_결과.xlsx`, kind: '결과', size: '2.4 MB', shared: true, state: 'ready' },
      { id: `auto-intermediate-${executionId}`, name: `실행_${executionId}_중간결과.zip`, kind: '중간 결과', size: '820 MB', shared: true, state: 'preparing' },
      { id: `auto-log-${executionId}`, name: `execution-${executionId}.log`, kind: '진단 로그', size: '42 KB', shared: true, state: safeExecution.diagnostic_failed ? 'partial-failure' : 'ready' },
    ],
    diagnostics: {
      parameters: { executionId, retry: 0, mode },
      logs: [`[INFO] 실행 #${executionId} 진단 로그`, safeExecution.error?.message || safeExecution.error || '[INFO] 수집된 오류 메시지가 없습니다.'],
    },
  }
}

export function resolveDraftLinkedContext(captured = {}, loaded = {}) {
  const findById = (items, entity) => {
    if (entity?.id == null) return null
    return (items || []).find(item => String(item?.id) === String(entity.id)) || null
  }
  const loadedPrimaryBlock = findById(loaded.blocks, captured.primaryBlock)
  const primaryBlock = loadedPrimaryBlock
    ? {
      ...loadedPrimaryBlock,
      ...(captured.primaryBlock?.error != null ? { error: clone(captured.primaryBlock.error) } : {}),
      ...(captured.primaryBlock?.status != null ? { status: captured.primaryBlock.status } : {}),
      ...(captured.primaryBlock?.run_status != null ? { run_status: captured.primaryBlock.run_status } : {}),
    }
    : captured.primaryBlock
  return {
    execution: normalizedEntity(findById(loaded.executions, captured.execution) || captured.execution),
    primaryBlock: normalizedEntity(primaryBlock),
    relatedBlocks: (captured.relatedBlocks || []).map(block => normalizedEntity(findById(loaded.blocks, block) || block)),
  }
}

export function selectProjectNavbarBlock(primaryBlock, block) {
  if (primaryBlock && String(primaryBlock.id) === String(block?.id)) return null
  return toCSIssueBlockContext(block)
}

export function normalizeDraftContext(source = 'menu', payload = {}) {
  const sourceType = {
    'workflow-error': '워크플로우 실행 오류',
    'workflow-result': '워크플로우 결과 이상',
    'data-result': '워크플로우 결과 이상',
  }
  const shouldSanitizeBlocks = source === 'project-navbar'
  const primaryBlock = shouldSanitizeBlocks
    ? toCSIssueBlockContext(payload.primaryBlock)
    : normalizedEntity(payload.primaryBlock)
  if (primaryBlock && source === 'workflow-error') {
    primaryBlock.status = 'failed'
    primaryBlock.run_status = 'fail'
  } else if (primaryBlock && source !== 'project-navbar' && primaryBlock.run_status === 'fail') {
    primaryBlock.status = primaryBlock.status || 'failed'
  }
  return {
    source,
    type: sourceType[source] || payload.type || '기타',
    project: normalizedEntity(payload.project),
    originScreen: normalizedEntity(payload.originScreen),
    workflow: normalizedEntity(payload.workflow),
    execution: normalizeExecutionSelection(source, payload.execution),
    primaryBlock,
    relatedBlocks: shouldSanitizeBlocks
      ? (payload.relatedBlocks || []).map(toCSIssueBlockContext).filter(Boolean)
      : clone(payload.relatedBlocks || []),
    resultFile: normalizedEntity(payload.resultFile),
    resultFiles: normalizeResultFiles(payload),
    workflowRunError: normalizeCSWorkflowRunErrorResponse(payload.workflowRunError),
  }
}

export function createDraft(state, context) {
  const id = `draft-${state.nextDraftId++}`
  state.drafts[id] = clone(context)
  return id
}

export function getDraft(state, id) {
  return state.drafts[id] ? clone(state.drafts[id]) : null
}

const waitingForStatus = status => {
  if (status === '고객 답변 대기' || status === '해결 확인 대기') return 'customer'
  if (status === '종료') return 'none'
  return 'recolumn'
}

export function createTicket(state, input, role = 'user') {
  const id = state.nextTicketId++
  const createdAt = nowIso()
  const reporter = actorForRole(role === 'cs_admin' ? 'user' : role)
  const organization = reporter.organizationId === 20 ? organizations.other : organizations.mine
  const context = clone(input.context || null)
  const ticket = {
    id,
    number: `CS-${new Date().getFullYear()}-${String(id).padStart(6, '0')}`,
    title: input.title,
    type: input.type,
    status: '접수',
    priority: ISSUE_PRIORITIES.includes(input.importance) ? input.importance : '보통',
    waitingFor: 'recolumn',
    reporter,
    organization: clone(organization),
    rootOrganization: clone(rootOrganizationFor(organization)),
    project: clone(context?.project || null),
    assignee: null,
    technicalAssignees: [],
    workflow: context?.workflow || null,
    execution: context?.execution || null,
    description: input.description,
    expectedResult: input.expectedResult || '',
    importance: input.importance || '보통',
    tags: [],
    cause: '',
    reproducible: '미확인',
    developmentIssue: '',
    targetFirstResponseAt: '',
    targetResolutionAt: '',
    unreadBy: ['cs_admin'],
    updatedAt: createdAt,
    createdAt,
    attachments: clone(input.attachments || []),
    snapshot: context ? {
      source: context.source,
      workflowRunError: normalizeCSWorkflowRunErrorResponse(context.workflowRunError),
      project: context.project,
      originScreen: context.originScreen,
      workflow: context.workflow,
      execution: context.execution,
      primaryBlock: context.primaryBlock,
      relatedBlocks: context.relatedBlocks || [],
      resultFile: context.resultFile,
      resultFiles: clone(context.resultFiles || (context.resultFile ? [context.resultFile] : [])),
      parameters: clone(input.parameters || context.diagnostics?.parameters || {}),
      logs: clone(input.logs || context.diagnostics?.logs || []),
      design: clone(context.designSnapshot || null),
      attachmentSnapshot: clone(input.attachments || []),
      warning: input.snapshotWarning || '',
    } : null,
    comments: [],
    internalNotes: [],
    history: [{ id: Date.now(), type: 'created', label: '티켓이 접수되었습니다.', createdAt }],
  }
  state.tickets.unshift(ticket)
  state.notifications.unshift({
    id: `ticket-created-${ticket.id}-${Date.now()}`,
    kind: '신규 문의',
    title: '새 CS 문의가 접수되었습니다.',
    message: `${ticket.number} 신규 티켓 알림과 이메일 발송이 예약되었습니다.`,
    ticketId: ticket.id,
    recipientRole: 'cs_admin',
    isRead: false,
    createdAt,
  })
  return ticket
}

export function updateTicket(state, id, patch, role) {
  const ticket = state.tickets.find(item => item.id === Number(id))
  if (!ticket) throw new Error('티켓을 찾을 수 없습니다.')
  if (role !== 'cs_admin' && Object.keys(patch).some(key => !['status'].includes(key))) throw new Error('변경 권한이 없습니다.')
  const changedPatch = Object.fromEntries(Object.entries(patch).filter(([key, value]) => (
    JSON.stringify(ticket[key]) !== JSON.stringify(value)
  )))
  const changedKeys = Object.keys(changedPatch)
  if (changedKeys.length === 0) return ticket

  const previousType = ticket.type
  Object.assign(ticket, clone(changedPatch), { updatedAt: nowIso() })
  if (changedPatch.status) ticket.waitingFor = waitingForStatus(changedPatch.status)

  const generalKeys = changedKeys.filter(key => key !== 'type')
  if (generalKeys.length > 0) {
    ticket.history.unshift({ id: Date.now(), type: 'updated', label: `${generalKeys.join(', ')} 항목이 변경되었습니다.`, createdAt: ticket.updatedAt })
  }
  if (changedKeys.includes('type')) {
    ticket.history.unshift({
      id: Date.now(),
      type: 'type',
      label: `문의 유형이 ${previousType}에서 ${ticket.type}로 변경되었습니다.`,
      createdAt: ticket.updatedAt,
      visibility: 'internal',
    })
  }
  if (changedPatch.status) state.notifications.unshift({
    id: `status-${ticket.id}-${Date.now()}`,
    kind: '상태 변경',
    title: 'CS 문의 상태가 변경되었습니다.',
    message: `${ticket.number} 상태가 ${changedPatch.status}(으)로 변경되었습니다.`,
    ticketId: ticket.id,
    recipientRole: role === 'cs_admin' ? ticket.reporter.role : 'cs_admin',
    isRead: false,
    createdAt: ticket.updatedAt,
  })
  return ticket
}

const requireInternalAssignmentAccess = (state, id, role) => {
  const ticket = state.tickets.find(item => item.id === Number(id))
  if (!ticket) throw new Error('티켓을 찾을 수 없습니다.')
  if (role !== 'cs_admin') throw new Error('내부 담당자 변경 권한이 없습니다.')
  return ticket
}

const assignmentLabel = type => type === 'technical' ? '기술 담당자' : 'CS 담당자'

const createAssignmentNotification = (state, ticket, member, type, action, createdAt) => {
  const label = assignmentLabel(type)
  const assigned = action === 'assigned'
  state.notifications.unshift({
    id: `${type}-${action}-${ticket.id}-${member.id}-${Date.now()}-${state.notifications.length}`,
    kind: assigned ? '담당자 배정' : '담당 해제',
    title: assigned
      ? `${member.name}님이 ${label}로 배정되었습니다.`
      : `${member.name}님의 ${label} 배정이 해제되었습니다.`,
    message: `${ticket.number} · ${ticket.title}`,
    ticketId: ticket.id,
    recipientRole: 'cs_admin',
    recipient: clone(member),
    assignmentType: type,
    assignmentAction: action,
    isRead: false,
    createdAt,
  })
}

export function setCSAssignee(state, id, assigneeId, role) {
  const ticket = requireInternalAssignmentAccess(state, id, role)
  const normalizedId = assigneeId === '' || assigneeId == null ? null : Number(assigneeId)
  const nextAssignee = normalizedId == null
    ? null
    : CS_ASSIGNEES.find(member => member.id === normalizedId)
  if (normalizedId != null && !nextAssignee) throw new Error('선택한 CS 담당자를 찾을 수 없습니다.')
  if ((ticket.assignee?.id ?? null) === (nextAssignee?.id ?? null)) return ticket

  const previousAssignee = ticket.assignee ? clone(ticket.assignee) : null
  const createdAt = nowIso()
  ticket.assignee = nextAssignee ? clone(nextAssignee) : null
  ticket.updatedAt = createdAt
  if (previousAssignee) createAssignmentNotification(state, ticket, previousAssignee, 'cs', 'released', createdAt)
  if (nextAssignee) createAssignmentNotification(state, ticket, nextAssignee, 'cs', 'assigned', createdAt)

  const label = previousAssignee && nextAssignee
    ? `CS 담당자가 ${previousAssignee.name}에서 ${nextAssignee.name}(으)로 변경되었습니다.`
    : nextAssignee
      ? `${nextAssignee.name}님이 CS 담당자로 배정되었습니다.`
      : `${previousAssignee.name}님의 CS 담당 배정이 해제되었습니다.`
  ticket.history.unshift({ id: Date.now(), type: 'cs-assignee', label, createdAt })
  return ticket
}

export function setTechnicalAssignees(state, id, assigneeIds, role) {
  const ticket = requireInternalAssignmentAccess(state, id, role)
  const uniqueIds = [...new Set((assigneeIds || []).map(value => Number(value)))]
  const nextAssignees = uniqueIds.map(memberId => {
    const member = TECHNICAL_ASSIGNEES.find(item => item.id === memberId)
    if (!member) throw new Error('선택한 기술 담당자를 찾을 수 없습니다.')
    return member
  })
  const previousAssignees = ticket.technicalAssignees || []
  const previousIds = new Set(previousAssignees.map(member => member.id))
  const nextIds = new Set(nextAssignees.map(member => member.id))
  const added = nextAssignees.filter(member => !previousIds.has(member.id))
  const released = previousAssignees.filter(member => !nextIds.has(member.id))
  if (!added.length && !released.length) return ticket

  const createdAt = nowIso()
  ticket.technicalAssignees = clone(nextAssignees)
  ticket.updatedAt = createdAt
  released.forEach(member => createAssignmentNotification(state, ticket, member, 'technical', 'released', createdAt))
  added.forEach(member => createAssignmentNotification(state, ticket, member, 'technical', 'assigned', createdAt))

  const changes = []
  if (added.length) changes.push(`배정: ${added.map(member => member.name).join(', ')}`)
  if (released.length) changes.push(`해제: ${released.map(member => member.name).join(', ')}`)
  ticket.history.unshift({
    id: Date.now(),
    type: 'technical-assignees',
    label: `기술 담당자가 변경되었습니다. (${changes.join(' · ')})`,
    createdAt,
    visibility: 'internal',
  })
  return ticket
}

export function addComment(state, id, input) {
  const ticket = state.tickets.find(item => item.id === Number(id))
  if (!ticket) throw new Error('티켓을 찾을 수 없습니다.')
  const createdAt = nowIso()
  const comment = {
    id: state.nextCommentId++,
    author: actorForRole(input.role),
    body: input.body,
    createdAt,
    visibility: 'public',
    requestInfo: Boolean(input.requestInfo),
    attachments: clone(input.attachments || []),
    edited: false,
    deleted: false,
    revisions: [],
  }
  ticket.comments.push(comment)
  ticket.waitingFor = input.role === 'cs_admin' ? 'customer' : 'recolumn'
  if (input.requestInfo) ticket.status = '고객 답변 대기'
  ticket.updatedAt = createdAt
  ticket.history.unshift({ id: Date.now(), type: 'commented', label: `${comment.author.name}님이 공개 댓글을 등록했습니다.`, createdAt })
  state.notifications.unshift({
    id: `comment-${ticket.id}-${comment.id}-${Date.now()}`,
    kind: '새 댓글',
    title: 'CS 문의에 새 댓글이 등록되었습니다.',
    message: `${ticket.number} 공개 댓글 알림이 묶음 발송 예정입니다.`,
    ticketId: ticket.id,
    recipientRole: input.role === 'cs_admin' ? ticket.reporter.role : 'cs_admin',
    isRead: false,
    createdAt,
  })
  return comment
}

export function addInternalNote(state, id, input) {
  if (input.role !== 'cs_admin') throw new Error('내부 메모 작성 권한이 없습니다.')
  const ticket = state.tickets.find(item => item.id === Number(id))
  if (!ticket) throw new Error('티켓을 찾을 수 없습니다.')
  const note = { id: state.nextNoteId++, author: actorForRole('cs_admin'), body: input.body, createdAt: nowIso(), visibility: 'internal' }
  ticket.internalNotes.push(note)
  ticket.updatedAt = note.createdAt
  ticket.history.unshift({ id: Date.now(), type: 'internal-note', label: '운영자 내부 메모가 등록되었습니다.', createdAt: note.createdAt })
  return note
}

export function editComment(state, ticketId, commentId, body, role) {
  const ticket = state.tickets.find(item => item.id === Number(ticketId))
  const comment = ticket?.comments.find(item => item.id === Number(commentId))
  if (!comment || comment.deleted) throw new Error('댓글을 찾을 수 없습니다.')
  if (role !== 'cs_admin' && comment.author.role !== role) throw new Error('댓글 수정 권한이 없습니다.')
  const editedAt = nowIso()
  comment.revisions = comment.revisions || []
  comment.revisions.push({ body: comment.body, editedAt })
  comment.body = body
  comment.edited = true
  comment.editedAt = editedAt
  ticket.updatedAt = editedAt
  ticket.history.unshift({ id: Date.now(), type: 'comment-edited', label: '공개 댓글이 수정되었습니다.', createdAt: editedAt })
  return comment
}

export function deleteComment(state, ticketId, commentId, role) {
  const ticket = state.tickets.find(item => item.id === Number(ticketId))
  const comment = ticket?.comments.find(item => item.id === Number(commentId))
  if (!comment || comment.deleted) throw new Error('댓글을 찾을 수 없습니다.')
  if (role !== 'cs_admin' && comment.author.role !== role) throw new Error('댓글 삭제 권한이 없습니다.')
  const deletedAt = nowIso()
  comment.revisions = comment.revisions || []
  comment.revisions.push({ body: comment.body, editedAt: deletedAt })
  comment.body = ''
  comment.attachments = []
  comment.deleted = true
  comment.deletedAt = deletedAt
  ticket.updatedAt = deletedAt
  ticket.history.unshift({ id: Date.now(), type: 'comment-deleted', label: '공개 댓글이 삭제되었습니다.', createdAt: deletedAt })
  return comment
}

export function updateAttachmentSharing(state, ticketId, attachmentId, shared, role) {
  const ticket = state.tickets.find(item => item.id === Number(ticketId))
  if (!ticket) throw new Error('티켓을 찾을 수 없습니다.')
  if (role !== 'cs_admin' && ticket.reporter?.role !== role) throw new Error('공유 범위 변경 권한이 없습니다.')
  const attachment = ticket.attachments.find(item => String(item.id) === String(attachmentId))
  if (!attachment) throw new Error('첨부 파일을 찾을 수 없습니다.')
  attachment.shared = Boolean(shared)
  const updatedAt = nowIso()
  ticket.updatedAt = updatedAt
  ticket.history.unshift({ id: Date.now(), type: 'attachment-sharing', label: `${attachment.name} 공유가 ${attachment.shared ? '포함' : '제외'}로 변경되었습니다.`, createdAt: updatedAt })
  return attachment
}

export function markAsRead(state, id, role) {
  const ticket = state.tickets.find(item => item.id === Number(id))
  if (!ticket) return
  ticket.unreadBy = ticket.unreadBy.filter(item => item !== role)
}
